import React from 'react';

import { TournamentsCalendar } from '@entities/tournaments';

const TournamentsPage = () => {
	return <TournamentsCalendar />;
};

export default TournamentsPage;
